<template>
  <Widget :title="$t('components.ReviewsByRating.Title')" :loading="loading" :report-mode="reportMode">
        <HorizontalBarChart :stats="stats" :styles="styles"/>
  </Widget>
</template>

<script>
/**
 * ReviewsRating wraps a StackedBarChart and contains the functions to parse
 * and format data from the API.
 */


import Widget from '@/components/dashboard/Widget';
import HorizontalBarChart from '../charts/HorizontalBarChart.vue';

export default {
  name: 'ReviewByRating',
  data: () => ({
    stats: {},
    styles: {
      position: 'relative',
      width: '100%',
      padding: '24px 24px 0',
    },
    groupBy: 'all',
    filterBy: 'rating',
    legend: [],
  }),
  props: {
    loading: {
      type: Boolean,
      default: true
    },
    reviewsData: {
      type: Object,
      required: true
    },
    reportMode: {
      type: String,
      default: null
    },
    appVersion: {
      type: String,
      default: ''
    }
  },
  computed: {
    isReport() {
      return this.reportMode !== null
    },
    colors() {
      return this.$vuetify.theme.isDark ?
          this.$vuetify.theme.themes.dark : this.$vuetify.theme.themes.light;
    }
  },
  mounted() {
    this.updateStats(this.reviewsData);
    console.log("STATS mounted");
  },
  watch: {
    reviewsData(newData) {
      this.updateStats(newData);
    }
  },
  methods: {
    updateStats(data) {
      if (data) {
        this.stats = this.formatItems(data.review_statistics.by_rating);
      }
    },
    formatItems(items) {
      const $t = this.$t.bind(this);
      const labels = [...Object.keys(items)];
      const datasets = [];
      const sessions = {
        label: $t("components.ReviewsByRating.ReviewsByRatingLabel"),
        backgroundColor: 'lightblue',
        fill: false,
        tension: 0,
        title: $t("components.ReviewsByRating.ReviewsByRatingLabel"),
        data: [],
        xtitle: $t("components.ReviewsByRating.SessionsXLabel"),
        ytitle: $t("components.ReviewsByRating.SessionsYLabel")
      }
      const {length} = labels;
      for (let i = 0; i < length; i++) {
        const item = items[labels[i]];
        sessions.data.push(item);
      }
      datasets.push(sessions);

      return {labels, datasets};
    }
  },
  components: {Widget, HorizontalBarChart}
}
</script>

<style>
.circle {
  display: inline-block;
  vertical-align: top;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  margin: 4px 12px;
}

.label {
  font-size: 1.2em !important;
}

.input-label.input-label {
  font-size: 1.02em !important;
}

.groupby .v-text-field__details {
  display: none;
}
</style>